import React from 'react';

import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export default function RoutesDetailsModal({
  show,
  handleClose,
  cities,
  totalOrders,
}) {
  const { t } = useTranslation(['title', 'glossary', 'description']);
  const cityNames = cities && cities.map((city) => city.city_name);
  return (
    <Modal animation={false} show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('routes.modal.details', { ns: 'title' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <span style={{ fontWeight: 'bold' }}>
            {`${t('city', { ns: 'glossary' })}: `}
          </span>
          {cityNames && cityNames.join(', ')}
        </p>
        <p>
          <span style={{ fontWeight: 'bold' }}>{`${t('orders_number', {
            ns: 'description',
          })}: `}</span>
          {totalOrders}
        </p>
      </Modal.Body>
    </Modal>
  );
}
